// extracted by mini-css-extract-plugin
module.exports = {"container":"UsersInputForm_container__3Beiw","username":"UsersInputForm_username__16BuP","age":"UsersInputForm_age__1jby1","btn":"UsersInputForm_btn__3V7NL"};